"use strict";
const timeZoneOptions = [
    {
        value: '-0800',
        offset: 8,
        dbName: 'Etc/GMT+8',
        label: '(GMT-8:00) Pacific Time (US & Canada)',
    },
    {
        value: '-0500',
        offset: 5,
        dbName: 'Etc/GMT+5',
        label: '(GMT-5:00) Eastern Time (US & Canada)',
    },
    {
        value: '-0600',
        offset: 6,
        dbName: 'Etc/GMT+6',
        label: '(GMT-6:00) Central Time (US & Canada)',
    },
    {
        value: '-0700',
        offset: 7,
        dbName: 'Etc/GMT+7',
        label: '(GMT-7:00) Mountain Time (US & Canada)',
    },
    {
        value: '+0100',
        offset: -1,
        dbName: 'Etc/GMT-1',
        label: '(GMT+1:00) Central European Time',
    },
    {
        value: '+0200',
        offset: -2,
        dbName: 'Etc/GMT-2',
        label: '(GMT+2:00) Eastern European Time',
    },
    {
        value: '+0300',
        offset: -3,
        dbName: 'Etc/GMT-3',
        label: '(GMT+3:00) Baghdad, Riyadh, Moscow, St. Petersburg',
    },
    {
        value: '+0330',
        offset: -3.5,
        dbName: 'Asia/Tehran',
        label: '(GMT+3:30) Tehran',
    },
    {
        value: '+0400',
        offset: -4,
        dbName: 'Etc/GMT-4',
        label: '(GMT+4:00) Abu Dhabi, Muscat, Baku, Tbilisi',
    },
    {
        value: '+0430',
        offset: -4.5,
        dbName: 'Asia/Kabul',
        label: '(GMT+4:30) Kabul',
    },
    {
        value: '+0500',
        offset: -5,
        dbName: 'Etc/GMT-5',
        label: '(GMT+5:00) Ekaterinburg, Islamabad, Karachi, Tashkent',
    },
    {
        value: '+0530',
        offset: -5.5,
        dbName: 'Asia/Calcutta',
        label: '(GMT+5:30) Bombay, Calcutta, Madras, New Delhi',
    },
    {
        value: '+0600',
        offset: -6,
        dbName: 'Etc/GMT-6',
        label: '(GMT+6:00) Almaty, Dhaka, Colombo',
    },
    {
        value: '+0700',
        offset: -7,
        dbName: 'Etc/GMT-7',
        label: '(GMT+7:00) Bangkok, Hanoi, Jakarta',
    },
    {
        value: '+0800',
        offset: -8,
        dbName: 'Etc/GMT-8',
        label: '(GMT+8:00) Beijing, Perth, Singapore, Hong Kong',
    },
    {
        value: '+0900',
        offset: -9,
        dbName: 'Etc/GMT-9',
        label: '(GMT+9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
    },
    {
        value: '+0930',
        offset: -9.5,
        dbName: 'Australia/Darwin',
        label: '(GMT+9:30) Adelaide, Darwin',
    },
    {
        value: '+1000',
        offset: -10,
        dbName: 'Etc/GMT-10',
        label: '(GMT+10:00) Eastern Australia, Guam, Vladivostok',
    },
    {
        value: '+1100',
        offset: -11,
        dbName: 'Etc/GMT-11',
        label: '(GMT+11:00) Magadan, Solomon Islands, New Caledonia',
    },
    {
        value: '+1200',
        offset: -12,
        dbName: 'Etc/GMT-12',
        label: '(GMT+12:00) Auckland, Wellington, Fiji, Kamchatka',
    },
    {
        value: '-1200',
        offset: 12,
        dbName: 'Etc/GMT+12',
        label: '(GMT-12:00) Eniwetok, Kwajalein',
    },
    {
        value: '-1100',
        offset: 11,
        dbName: 'Etc/GMT+11',
        label: '(GMT-11:00) Midway Island, Samoa',
    },
    {
        value: '-1000',
        offset: 10,
        dbName: 'Etc/GMT+10',
        label: '(GMT-10:00) Hawaii',
    }, {
        value: '+1300',
        offset: -13,
        dbName: 'Etc/GMT-13',
        label: '(GMT+13:00) West Samoa',
    },
    {
        value: '-0900',
        offset: 9,
        dbName: 'Etc/GMT+9',
        label: '(GMT-9:00) Alaska',
    },
    {
        value: '-0400',
        offset: 4,
        dbName: 'Etc/GMT+4',
        label: '(GMT-4:00) Atlantic Time (Canada), La Paz',
    },
    {
        value: '-0330',
        offset: 3.5,
        dbName: 'Canada/Newfoundland',
        label: '(GMT-3:30) Newfoundland',
    },
    {
        value: '-0300',
        offset: 3,
        dbName: 'Etc/GMT+3',
        label: '(GMT-3:00) Brazil, Buenos Aires, Georgetown',
    },
    {
        value: '-0200',
        offset: 2,
        dbName: 'Etc/GMT+2',
        label: '(GMT-2:00) Mid-Atlantic',
    },
    {
        value: '-0100',
        offset: 1,
        dbName: 'Etc/GMT+1',
        label: '(GMT-1:00) Azores, Cape Verde Islands',
    },
    {
        value: '+0000',
        offset: 0,
        dbName: 'Etc/GMT+0',
        label: '(GMT+00:00), Greenwich Mean Time',
    },
];
module.exports = {
    timeZoneOptions,
};
//# sourceMappingURL=consts.js.map